import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=5f452208"
import script from "./EventPreview.vue?vue&type=script&lang=js"
export * from "./EventPreview.vue?vue&type=script&lang=js"
import style0 from "./EventPreview.vue?vue&type=style&index=0&id=5f452208&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f452208')) {
      api.createRecord('5f452208', component.options)
    } else {
      api.reload('5f452208', component.options)
    }
    module.hot.accept("./EventPreview.vue?vue&type=template&id=5f452208", function () {
      api.rerender('5f452208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EventPreview.vue"
export default component.exports